module.exports = __webpack_public_path__ + "img/9788977289314.ba2fce7a.jpg";